import React from "react";
import "./Partners.css";
import partnerImg1 from "../../Images/partnerImg1.jpg";
import partnerImg2 from "../../Images/partnerImg2.jpg";
import partnerImg3 from "../../Images/partnerImg3.png";

const Partners = () => {
  return (
    <div className="partnersSection">
      <div className="partnersHero">
        <img src={partnerImg1} alt="partnerImg1" />
        <div className="partnersHeroCover">
          <div className="partnersHeroText">
            <h1>Restoring Careers, Together</h1>
            <p>
              Together with colleges, NGOs, and corporations, we’re restoring
              careers and reshaping futures.
            </p>
            <a href="/joinPartnerForm">
              <button>Join as Partner</button>
            </a>
          </div>
        </div>
      </div>
      <div className="partnersBlock">
        <img src={partnerImg2} alt="partnerImg2" />
        <div className="partnersBlockText">
          <h2>Together, We Restore Careers and Build Futures</h2>
          <p>
            At Career Restorer, our partners are more than collaborators—they're
            catalysts for change. From forward-thinking colleges to
            mission-driven NGOs and visionary corporations, each alliance helps
            us unlock new opportunities, empower individuals, and reshape the
            future of work. Explore how these partnerships fuel transformation
            across education, employment, and community impact.
          </p>
        </div>
      </div>
      <div className="collegePartners">
        <h2>Training Programs for Students</h2>
        <p>
          We offer hands-on training in Banking, Finance, HR, Accounts, Digital
          Marketing, and more—designed to bridge the gap between academics and
          industry. Our programs equip students with practical skills,
          certifications, and career-ready confidence.
        </p>
        <div className="collegeSection">
          <div className="collegeCards">
            <h3>Banking & Finance</h3>
            <p>
              Retail banking, financial products, compliance, investment basics
            </p>
          </div>
          <div className="collegeCards">
            <h3>Accounts</h3>
            <p>
              Tally ERP, GST, payroll, reconciliation, Practical accounting,
              ledger management, tax basics
            </p>
          </div>
          <div className="collegeCards">
            <h3>Human Resources</h3>
            <p>
              Recruitment, onboarding, HRMS tools, labor laws, Interviewing,
              documentation, employee engagement
            </p>
          </div>
          <div className="collegeCards">
            <h3>Digital Marketing</h3>
            <p>
              SEO, SEM, social media, email marketing, analytics, Campaign
              creation, content strategy, performance tracking
            </p>
          </div>
          <div className="collegeCards">
            <h3>BPO (Voice & Non-Voice)</h3>
            <p>
              Communication skills, CRM tools, call handling, Accent training,
              customer service, ticketing systems
            </p>
          </div>
        </div>
        <button>
          <a href="/collegePartner">Explore More</a>
        </button>
      </div>
      <div className="ngoSection">
        <h2>CSR & NGO</h2>
        <div className="ngoblock">
          <div className="ngoblockText1">
            <h3>What is CSR & NGO?</h3>
            <p>
              <b>Corporate Social Responsibility (CSR)</b> means companies
              taking action to give back to society—like supporting education,
              environment, or health.
            </p>
            <p>
              <b>Non-Governmental Organizations (NGOs)</b> are independent,
              nonprofit groups that work on social and humanitarian issues.
            </p>
            <p>
              CSR and NGOs both help create opportunities for learning,
              internships, and career growth while building a better society.
            </p>
          </div>
          <div className="ngoblockText1">
            <h3>CSR Activities & Impact</h3>
            <p>
              <i class="fa-solid fa-check"></i>
              Educational programs and scholarships for underprivileged
              students.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>Skill development workshops and
              vocational training.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>Environmental conservation and
              awareness campaigns.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>Health and wellness camps for
              communities.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>Support for research & innovation
              initiatives.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>
              These efforts create real career-building opportunities through
              internships and training programs.
            </p>
          </div>
        </div>
        <div className="ngoCollaboration">
          <div className="collaborationImg">
            <img src={partnerImg3} alt="partnerImg3" />
          </div>
          <div className="collaborationText">
            <h3>NGO Collaborations & Opportunities</h3>
            <p>
              We partner with NGOs working in education, women empowerment,
              training, and welfare. Many offer volunteer and internship roles.
            </p>
            <p>
              Join to gain experience, grow your network, and contribute to
              social change.
            </p>
          </div>
        </div>
        <button>
          <a href="/ngoPartner">Explore More</a>
        </button>
      </div>
      <div className="collegePartners">
        <h2>Corporate Partnerships & Opportunities</h2>
        <p>
          We collaborate with forward-thinking corporations that are committed
          to nurturing talent and shaping the future workforce. These
          partnerships bridge the gap between education and employment, offering
          real-world exposure and career advancement.
        </p>
        <div className="collegeSection">
          <div className="collegeCards">
            <h3>Industry-Aligned Training</h3>
            <p>
              Corporates help design and deliver training programs in Banking,
              Finance, HR, Digital Marketing, and more.
            </p>
          </div>
          <div className="collegeCards">
            <h3>Internships & Live Projects</h3>
            <p>
              Students gain hands-on experience through corporate-sponsored
              internships and project-based learning.
            </p>
          </div>
          <div className="collegeCards">
            <h3>Mentorship & Career Guidance</h3>
            <p>
              Professionals from partner companies mentor aspiring candidates,
              offering insights into industry trends and career paths.
            </p>
          </div>
          <div className="collegeCards">
            <h3>Placement Support</h3>
            <p>
              Our corporate network actively recruits skilled candidates,
              creating direct pathways to employment.
            </p>
          </div>
          <div className="collegeCards">
            <h3>Innovation & Research Collaboration</h3>
            <p>
              Companies support research initiatives and encourage innovation
              through joint programs and hackathons.
            </p>
          </div>
        </div>
        <button>
          <a href="/corporatePartner">Explore More</a>
        </button>
      </div>
    </div>
  );
};

export default Partners;
